"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@indigenux/design/components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Password = _ref => {
  let {
    text,
    value,
    onChange,
    maxLength,
    name,
    required,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Label, {
      children: text
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "password",
      value: value,
      onChange: onChange,
      className: "form-control form-control-lg text-4",
      name: name,
      required: required ? 'required' : '',
      ...rest
    })]
  });
};
var _default = exports.default = Password;